import { components } from '@bumble/app/theme/components';
import { palette } from '@bumble/app/theme/palette';
import { typography } from '@bumble/app/theme/typography';
import {
  type SxProps as BaseSxProps,
  Shadows,
  type ThemeOptions,
  createTheme,
} from '@mui/material/styles';

const mainThemeConfig: ThemeOptions = {
  typography,
  palette,
  // shadows: Array(25).fill('none') as Shadows,
  spacing: 4,
  shape: {
    borderRadius: 8,
  },
  components,
};

export const theme = createTheme(mainThemeConfig);
export type SxProps = BaseSxProps<typeof theme>;
